module.exports = "/_next/static/images/RoostifyLogo-5e870229b12da990fd237b47d3b5becb.png";